import { Component, Input, OnChanges } from "@angular/core";
import { CleanFilePathService } from "../../clean-file/clean-file-path.service";

@Component({
  selector: "ab-file-line",
  templateUrl: "./file-line.component.html",
})
export class FileLineComponent implements OnChanges {
  @Input() public file: string;
  @Input() public line: number;
  @Input() public column: number;
  @Input() public repoUrl: string;
  @Input() public gitRevision: string;
  @Input() public rootDir: string;
  public displayAs: string;
  public name: string;
  public path: string;
  public url: string;

  constructor(private cleanFilePathService: CleanFilePathService) {}

  public ngOnChanges() {
    this.render();
  }

  private render() {
    let repoUrl: string;
    const opt = {
      repoUrl: this.repoUrl || "",
      gitRevision: this.gitRevision || "",
    };

    if (isUrl(this.file)) {
      this.displayAs = "link";
      this.url = this.file;
      // tslint:disable-next-line:no-conditional-assignment
    } else if ((repoUrl = makeRepoUrl(this.file, this.line, opt)) !== "") {
      this.displayAs = "link";
      this.url = repoUrl;
    } else {
      this.displayAs = "text";
    }

    const file = this.cleanFilePathService.clean(this.file, this.rootDir);
    return ([this.path, this.name] = splitFile(file));
  }
}

const PROJECT_ROOT = "/PROJECT_ROOT/";
const PROJECT_ROOT2 = "[PROJECT_ROOT]/";
const WEBPACK_ROOT = "webpack:///";
const BITBUCKET_ORG = "https://bitbucket.org";

function isUrl(s: string) {
  if (s == null) {
    return false;
  }
  for (const prefix of ["http://", "https://", "www."]) {
    if (s.startsWith(prefix)) {
      return true;
    }
  }
  return false;
}

function splitFile(s: string) {
  let name: string;
  let path: string;
  const pos = s.lastIndexOf("/");
  if (pos === -1) {
    path = "";
    name = s;
  } else {
    path = s.slice(0, +pos + 1 || undefined);
    name = s.slice(pos + 1);
  }
  return [path, name];
}

function splitRepoName(url: string): string {
  const sep = "://";
  const ind = url.indexOf(sep);
  if (ind !== -1) {
    url = url.slice(ind + sep.length);
  }
  return url;
}

function makeRepoUrl(file: string, line: number, opt: any): string {
  if (!file) {
    return "";
  }

  const GOPATH = "/GOPATH/";
  if (file.startsWith(GOPATH)) {
    const s = file.slice(GOPATH.length);
    if (s.startsWith("github.com")) {
      return githubFileLineUrl(s, line);
    }
  }

  if (!opt.repoUrl) {
    return "";
  }

  if (file.startsWith(PROJECT_ROOT)) {
    file = file.slice(PROJECT_ROOT.length);
  } else if (file.startsWith(PROJECT_ROOT2)) {
    file = file.slice(PROJECT_ROOT2.length);
  } else if (file.startsWith(WEBPACK_ROOT)) {
    file = file.slice(WEBPACK_ROOT.length);
  } else {
    return "";
  }

  const repoName = splitRepoName(opt.repoUrl) + "/";
  if (file.startsWith(repoName)) {
    file = file.slice(repoName.length);
  }

  let rev;
  if (opt.gitRevision !== "") {
    rev = gitRevisionPath(opt.repoUrl, opt.gitRevision);
  } else {
    rev = masterRevisionPath(opt.repoUrl);
  }

  let url = `${opt.repoUrl}/${rev}/${file}`;
  if (line > 0) {
    url += linePath(opt.repoUrl, line);
  }

  return url;
}

function linePath(repoUrl: string, line: number) {
  if (repoUrl.startsWith(BITBUCKET_ORG)) {
    return `#lines-${line}`;
  } else {
    return `#L${line}`;
  }
}

function masterRevisionPath(repoUrl: string) {
  if (repoUrl.startsWith(BITBUCKET_ORG)) {
    return "src/master";
  } else {
    return "tree/master";
  }
}

function gitRevisionPath(repoUrl: string, gitRevision: string) {
  if (repoUrl.startsWith(BITBUCKET_ORG)) {
    return `src/${gitRevision}`;
  } else {
    return `blob/${gitRevision}`;
  }
}

function githubFileLineUrl(file: string, line: number): string {
  let ind = -1;
  for (let i = 0; i < 3; i++) {
    ind = file.indexOf("/", ind + 1);
    if (ind === -1) {
      return "";
    }
  }

  const repo = file.slice(0, ind);
  file = file.slice(ind + 1);

  let url = `https://${repo}/tree/master/${file}`;
  if (line > 0) {
    url += `#L${line}`;
  }

  return url;
}
